<template>
    <form-group
        v-bind="form_group_props"
    >
        <template v-slot:read_only>
            <slot name="read_only">
                <div v-html="value" class="uk-margin-small-top"></div>
            </slot>
        </template>
        <template v-slot:label><slot name="label"></slot></template>
        <template v-slot:hint><slot name="hint"></slot></template>
        <input-group
            v-bind="input_group_props"
        >
            <textarea
                ref="field"
                :id="identifier"
                :name="name"
                :value="value"
                :aria-describedby="!!has_slot('hint')?`${identifier}-description`:false"
                :disabled="disabled"
                :placeholder="placeholder"
                @keydown="keydown"
                @blur="blur"
                :rows="(size==='medium')?4:false"
                :class="{ [`uk-width-${width}`]: true, [`uk-text-${align}`]: true, 'lam-tall': (size === 'large'), 'lam-single-line-textarea': (size === 'small'), 'uk-height-1-1': ((size === 'normal') && !!height) }"
                class="form-input"
            ></textarea>
        </input-group>
    </form-group>
</template>

<script>
import debounce from "lodash/debounce"

import is_nibnut_component from "../mixins/IsNibnutComponent"

import FormGroup from "./FormGroup"
import InputGroup from "./InputGroup"

export default {
    name: "FormTextArea",
    mixins: [is_nibnut_component],
    components: {
        FormGroup,
        InputGroup
    },
    watch: {
        // editable: "maybe_focus_field"
    },
    methods: {
        focus_field () {
            this.$refs.field.focus()
            this.$refs.field.select()
        },
        maybe_focus_field () {
            if(this.editable) setTimeout(this.focus_field, 150)
        },
        keydown: debounce(function (event) {
            if(this.live) this.$emit("input", event.target.value, this.name)
        }, 300),
        blur (event) {
            const value = event.target.value
            if(!this.live) this.$emit("input", value, this.name)
            this.$emit("blur", value, this.name) // can be useful for autofilled values... Use this to manually set your v-model's value
        }
    },
    computed: {
        form_group_props () {
            return {
                id: this.id,
                name: this.name,
                height: this.height,
                value: this.value,
                required: this.required,
                editable: this.editable,
                error: this.error,
                waiting: this.saving
            }
        },
        input_group_props () {
            return {
                height: this.height,
                glyph: this.glyph
            }
        }
    },
    props: {
        id: {
            type: String,
            validator: prop => !!prop
        },
        name: {
            type: String,
            validator: prop => !!prop,
            required: true
        },
        value: {
            default: ""
        },
        width: {
            type: String,
            default: "1-1"
        },
        height: {
            type: String,
            default: ""
        },
        size: {
            type: String,
            validator: prop => !!prop && !!prop.match(/^(small|normal|medium|large)$/i),
            default: "normal"
        },
        align: {
            type: String,
            validator: prop => !!prop && !!prop.match(/^(left|right|center)$/i),
            default: "left"
        },
        placeholder: {
            type: String,
            default: ""
        },
        required: {
            type: Boolean,
            required: true
        },
        editable: {
            type: Boolean,
            default: true
        },
        disabled: {
            type: Boolean,
            default: false
        },
        live: {
            type: Boolean,
            default: false
        },
        saving: {
            type: Boolean,
            default: false
        },
        error: {
            type: String,
            default: ""
        }
    }
}
</script>
